module.exports = __webpack_public_path__ + "static/media/sub-contract-mgmt.823a10cf.svg";